export default __webpack_public_path__ + "img/crop.805b873c.svg";